import * as i from 'io-ts';
import * as Option from './option';
import rison from 'rison';
import { pipe } from 'fp-ts/lib/function';
import { postSelections } from '../../requests/configuration/getSelections';
import * as TE from 'fp-ts/TaskEither';
import * as E from 'fp-ts/Either';
import * as Err from '@fixtuur/error-context';
import { RequestError } from '../../requests/requestError';
const Selections = i.record(Option.Name, Option.Value);
const isSelections = (u) => E.isRight(Selections.decode(u));
export const toString = (selections) => rison.encode_object(selections);
export const proposalToString = (proposal) => rison.encode_array(proposal);
export const createSimple = (name, value) => ({
    [name]: value,
});
/**
 * Returns Options and Selections from the response data.
 * The proposal defines what properties the Selections will include.
 */
export const fromProposal = (serviceConfig, spaceId, proposal) => {
    return pipe(postSelections(serviceConfig, spaceId, proposal), TE.chain(response => {
        if (!isSelections(response.data.selections)) {
            return TE.left(Err.construct(RequestError.ResponseNotExpectedFormat, {
                responseStatus: response.status.toString(10),
                responseStatusText: response.statusText,
            }));
        }
        // TODO: error handling if (!isOptions) ...?
        return TE.right({
            options: response.data.options.properties,
            selections: response.data.selections,
        });
    }));
};
